module.exports = __webpack_public_path__ + "static/2-c9f9826a12ad4d860eb17dbc3150926e.jpg";